import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { getEventScheduleToken } from "@/api/index";
import { handleSSOLogin } from "@/utils/sso-login";
import { clearToken, getStoreToken } from "../utils/token";
import { getEventUserInfo } from "@/api/user";
import { getEventId, getBookJurorUrl, isAssociate, getEventSchedule } from "@/api/event";
import zhuanjiaIcon1 from "@/assets/img/zhuanjia1.png";
export default {
  name: "ACtivity",
  mixins: [],
  props: {},
  data() {
    return {
      show: false,
      iframeUrl: "",
      activeId: 0,
      current: {},
      menubar: [],
      eventId: "",
      userInfo: {},
      isAssociate: false,
      currentTime: "",
      compEventSchedule: {},
      cmsId: this.$route.query.cmsId || 10111,
      eventSchedule: [],
      showMask: false // 新增蒙层状态
    };
  },
  computed: {
    noticeUrl() {
      let url = "";
      if (window.parent.location.href.includes("server-front")) {
        url = process.env.VUE_APP_SITE_URL + "/server-front/front/content/" + this.detailId;
      } else {
        url = process.env.VUE_APP_SITE_URL + process.env.VUE_APP_USER_INFO_PATH + this.detailId;
      }
      return url;
    }
  },
  watch: {
    menubar: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          // 默认选中第一个
          this.current = newValue[0];
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (!getStoreToken()) {
      handleSSOLogin();
    } else {
      this.$router.push({
        path: "/review",
        query: {
          ...this.$route.query,
          _t: new Date().getTime()
        }
      });
      this.iframeUrl = "";
      this.show = true;
      // this.getEventId();
    }
  },
  mounted() {},
  beforeRouteUpdate(to, from, next) {
    this.getEventId();
    next();
  },
  methods: {
    handleNoticeClick() {
      if (process.env.VUE_APP_PROFESSOR_NOTICE_URL) {
        window.open(process.env.VUE_APP_PROFESSOR_NOTICE_URL, "_blank");
      }
    },
    async getEventId() {
      let res = await getEventId(this.cmsId);
      if (res.code == 200) {
        this.eventId = res.data.id;
        this.getEventUserInfo();
      } else if (res.code == 401) {
        clearToken();
        handleSSOLogin();
      }
    },
    async getEventUserInfo() {
      let res = await getEventUserInfo(this.eventId);
      if (res.code == 200) {
        this.currentTime = res.time;
        this.userInfo = res.data;
        this.compEventSchedule = this.userInfo.compEventSchedule || {};
        const res1 = await isAssociate(this.eventId);
        if (res1.code == 5101) {
          setTimeout(() => {
            window.parent.location.href = process.env.VUE_APP_HOME_URL;
          }, 3000);
          return;
        }
        this.isAssociate = res1.data.isAssociate != "N";
        if (this.isAssociate) {
          let res2 = await getEventSchedule(this.eventId, 2);
          if (res2.code == 200) {
            var _res2$data$scheduleLi, _res2$data;
            this.eventSchedule = (_res2$data$scheduleLi = (_res2$data = res2.data) === null || _res2$data === void 0 ? void 0 : _res2$data.scheduleList) !== null && _res2$data$scheduleLi !== void 0 ? _res2$data$scheduleLi : [];
            if (this.eventSchedule.length == 0) {
              this.showMask = true;
              this.$message.warning("未查询到相关活动");
              setTimeout(() => {
                window.parent.location.href = process.env.VUE_APP_HOME_URL;
              }, 3000);
              return;
            } else {
              const index = this.eventSchedule.findIndex(
              // (ele) => ele.scheduleType == 3
              ele => ele.scheduleProcessType == 2);
              if (index == -1) {
                this.showMask = true;
                this.$message.warning("未查询到相关活动");
                setTimeout(() => {
                  window.parent.location.href = process.env.VUE_APP_HOME_URL;
                }, 3000);
              } else {
                this.compEventSchedule = this.eventSchedule[index];
              }
            }
          }
          let startTime = this.compEventSchedule.startTime;
          let endTime = this.compEventSchedule.endTime;
          if (startTime && endTime) {
            if (new Date(startTime).getTime() <= this.currentTime && new Date(endTime).getTime() > this.currentTime) {
              getBookJurorUrl(this.eventId).then(res => {
                if (res.code == 200) {
                  window.parent.location.href = res.data;
                }
              });
            } else {
              let res2 = await getEventSchedule(this.eventId, 2);
              if (res2.code == 200) {
                var _res2$data$scheduleLi2, _res2$data2;
                this.eventSchedule = (_res2$data$scheduleLi2 = (_res2$data2 = res2.data) === null || _res2$data2 === void 0 ? void 0 : _res2$data2.scheduleList) !== null && _res2$data$scheduleLi2 !== void 0 ? _res2$data$scheduleLi2 : [];
              }
              if (this.eventSchedule.length == 0) {
                this.showMask = true;
                this.$message.warning("评审活动暂未开放");
                setTimeout(() => {
                  window.parent.location.href = process.env.VUE_APP_HOME_URL;
                }, 3000);
                return;
              }
              this.menubar = [];
              this.eventSchedule.forEach(ele => {
                this.menubar.push({
                  title: ele.scheduleName,
                  path: "/home",
                  id: ele.id,
                  icon: zhuanjiaIcon1,
                  scheduleType: ele.scheduleType,
                  startTime: ele.startTime,
                  endTime: ele.endTime
                });
              });
              if (this.eventSchedule.length > 0) {
                this.current = this.menubar[0];
                this.getEventScheduleToken(this.current.id);
                let startTime = this.current.startTime;
                let endTime = this.current.endTime;
                if (new Date(endTime).getTime() < this.currentTime) {
                  this.showMask = true;
                  this.$message.warning("评审活动已结束");
                  setTimeout(() => {
                    window.parent.location.href = process.env.VUE_APP_HOME_URL;
                  }, 3000);
                } else if (new Date(startTime).getTime() > this.currentTime) {
                  this.showMask = true;
                  this.$message.warning("评审活动暂未开放");
                  setTimeout(() => {
                    window.parent.location.href = process.env.VUE_APP_HOME_URL;
                  }, 3000);
                }
              }
            }
          }
        } else {
          let res2 = await getEventSchedule(this.eventId, 2);
          if (res2.code == 200) {
            var _res2$data$scheduleLi3, _res2$data3;
            this.eventSchedule = (_res2$data$scheduleLi3 = (_res2$data3 = res2.data) === null || _res2$data3 === void 0 ? void 0 : _res2$data3.scheduleList) !== null && _res2$data$scheduleLi3 !== void 0 ? _res2$data$scheduleLi3 : [];
          }
          this.menubar = [];
          this.eventSchedule.forEach(ele => {
            if (ele.scheduleType == 1) {
              this.menubar.push({
                title: ele.scheduleName,
                path: "/home",
                id: ele.id,
                icon: zhuanjiaIcon1,
                scheduleType: ele.scheduleType,
                startTime: ele.startTime,
                endTime: ele.endTime
              });
            }
          });
          if (this.menubar.length == 0) {
            this.showMask = true;
            this.$message.warning("评审活动暂未开放");
            setTimeout(() => {
              window.parent.location.href = process.env.VUE_APP_HOME_URL;
            }, 3000);
            return;
          }
          if (this.menubar.length > 0) {
            this.current = this.menubar[0];
            console.log("current=====", this.current);
            this.getEventScheduleToken(this.current.id);
            let startTime = this.current.startTime;
            let endTime = this.current.endTime;
            if (new Date(endTime).getTime() < this.currentTime) {
              this.showMask = true;
              this.$message.warning("评审活动已结束");
              setTimeout(() => {
                window.parent.location.href = process.env.VUE_APP_HOME_URL;
              }, 3000);
            } else if (new Date(startTime).getTime() > this.currentTime) {
              this.showMask = true;
              this.$message.warning("评审活动暂未开放");
              setTimeout(() => {
                window.parent.location.href = process.env.VUE_APP_HOME_URL;
              }, 3000);
            }
          }
        }
      }
    },
    // thi
    async getEventScheduleToken(id) {
      let res = await getEventScheduleToken(id);
      if (res.code === 401) {
        clearToken();
        handleSSOLogin();
      }
      if (res.data) {
        this.iframeUrl = res.data.formUrl;
        // let startTime = this.current.startTime;
        // let endTime = this.current.endTime;
        // if (startTime && endTime) {
        //   if (new Date(endTime).getTime() < this.currentTime) {
        //     this.$message.warning("当前报名日程已结束");
        //   } else if (new Date(startTime).getTime() > this.currentTime) {
        //     this.$message.warning("当前报名日程尚未开始");
        //   }
        //   setTimeout(() => {
        //     window.parent.location.href = process.env.VUE_APP_HOME_URL;
        //   }, 2000);
        // }
      }
    },
    adjustIframeHeight() {
      const iframe = this.$refs.activityIframe;
      if (iframe) {
        const contentWindow = iframe.contentWindow;
        const contentDocument = contentWindow.document;
        const height = Math.max(contentDocument.body.scrollHeight, contentDocument.documentElement.scrollHeight, contentDocument.body.offsetHeight, contentDocument.documentElement.offsetHeight, contentDocument.body.clientHeight, contentDocument.documentElement.clientHeight);
        iframe.style.height = `${Math.max(height, 1000)}px`;
      }
    },
    handleSSOLogin() {
      handleSSOLogin();
    },
    getBookJurorUrl() {
      getBookJurorUrl(this.eventId).then(res => {
        if (res.code == 200) {
          window.open(res.data, "_blank");
        }
      });
    },
    async hanldeMenuClick(item) {
      console.log(1111, item);
      if (item.scheduleType == 1) {
        this.getEventScheduleToken(item.id);
        let res = await getEventUserInfo(this.eventId);
        if (res.code == 200) {
          this.currentTime = res.time;
          this.userInfo = res.data;
          this.current = item;
          this.compEventSchedule = this.userInfo.compEventSchedule || {};
        }
      } else if (item.scheduleType == 3) {
        if (item.startTime && new Date(this.compEventSchedule.startTime).getTime() > this.currentTime) {
          this.$message.warning("活动已结束。");
          return;
        }
        if (this.compEventSchedule.endTime && new Date(this.compEventSchedule.endTime).getTime() < this.currentTime) {
          this.$message.warning("评审活动已结束。");
          return;
        }
        this.getBookJurorUrl();
      }
    }
  }
};